import {httpConstants} from "../constants";
import {httpService} from "../utility/httpService";

export default {
    getPlansList,
    getSubscriptionList,
    updateSubscription,
    updatePlan,
    addPlans,
}

async function addPlans(req) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.PLAN;
    return httpService(httpConstants.METHOD_TYPE.POST, getHeaders(), req, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function getPlansList(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.PLANS_LIST;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function updatePlan(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.PLAN;
    return httpService(httpConstants.METHOD_TYPE.PUT, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}

async function getSubscriptionList(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.SUBSCRIPTION_LIST;
    return httpService(httpConstants.METHOD_TYPE.GET, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}


async function updateSubscription(requestData) {
    let url = httpConstants.BASE_URL + httpConstants.API_END_POINT.SUBSCRIPTION;
    return httpService(httpConstants.METHOD_TYPE.PUT, getHeaders(), requestData, url)
        .then(
            response => {
                if (!response.success || response.responseCode !== 200 || !response.responseData || response.responseData.length === 0)
                    return Promise.reject(response);
                return Promise.resolve(response.responseData);
            }
        ).catch(function (err) {
            return Promise.reject(err);
        });
}


function getHeaders() {
    return {'Content-Type': httpConstants.CONTENT_TYPE.APPLICATION_JSON, 'skip': true}
}
